var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCotizar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "pl",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--a",
    cx: 120,
    cy: 120,
    r: 105,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 660",
    strokeDashoffset: -330,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--b",
    cx: 120,
    cy: 120,
    r: 35,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 220",
    strokeDashoffset: -110,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--c",
    cx: 85,
    cy: 120,
    r: 70,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 440",
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "pl__ring pl__ring--d",
    cx: 155,
    cy: 120,
    r: 70,
    fill: "none",
    stroke: "#000",
    strokeWidth: 20,
    strokeDasharray: "0 440",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotizar);
export default __webpack_public_path__ + "static/media/Cotizar.055208115d192ca5153eaec66c8ac607.svg";
export { ForwardRef as ReactComponent };